import React from 'react';
export function CryptoCardSkeleton() {
  return <div className="bg-white rounded-lg border border-gray-200 p-5 animate-pulse" data-id="element-136">
      <div className="flex items-center justify-between" data-id="element-137">
        <div className="flex items-center gap-4 flex-1" data-id="element-138">
          <div className="flex items-center gap-3" data-id="element-139">
            <div className="w-6 h-4 bg-gray-200 rounded" data-id="element-140"></div>
            <div className="w-10 h-10 bg-gray-200 rounded-full" data-id="element-141"></div>
          </div>
          <div className="flex-1" data-id="element-142">
            <div className="flex items-center gap-2 mb-2" data-id="element-143">
              <div className="h-5 bg-gray-200 rounded w-32" data-id="element-144"></div>
              <div className="h-4 bg-gray-200 rounded w-12" data-id="element-145"></div>
            </div>
            <div className="h-6 bg-gray-200 rounded w-24" data-id="element-146"></div>
          </div>
        </div>
        <div className="text-right" data-id="element-147">
          <div className="h-5 bg-gray-200 rounded w-28 mb-2" data-id="element-148"></div>
          <div className="h-4 bg-gray-200 rounded w-16 ml-auto" data-id="element-149"></div>
        </div>
      </div>
    </div>;
}
export function ExchangeCardSkeleton() {
  return <div className="bg-white rounded-lg border border-gray-200 p-6 animate-pulse" data-id="element-150">
      <div className="flex items-start gap-4 mb-4" data-id="element-151">
        <div className="flex items-center gap-3" data-id="element-152">
          <div className="w-6 h-4 bg-gray-200 rounded" data-id="element-153"></div>
          <div className="w-12 h-12 bg-gray-200 rounded" data-id="element-154"></div>
        </div>
        <div className="flex-1" data-id="element-155">
          <div className="flex items-center justify-between mb-2" data-id="element-156">
            <div className="h-6 bg-gray-200 rounded w-32" data-id="element-157"></div>
            <div className="h-6 bg-gray-200 rounded w-16" data-id="element-158"></div>
          </div>
          <div className="h-4 bg-gray-200 rounded w-full" data-id="element-159"></div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-160">
        {[1, 2, 3, 4].map(i => <div key={i} data-id="element-161">
            <div className="h-3 bg-gray-200 rounded w-20 mb-2" data-id="element-162"></div>
            <div className="h-5 bg-gray-200 rounded w-24" data-id="element-163"></div>
          </div>)}
      </div>

      <div className="flex gap-2" data-id="element-164">
        {[1, 2, 3].map(i => <div key={i} className="h-6 bg-gray-200 rounded w-20" data-id="element-165"></div>)}
      </div>
    </div>;
}
export function GlobalStatsSkeleton() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 animate-pulse" data-id="element-166">
      {[1, 2, 3].map(i => <div key={i} className="bg-white/10 rounded-lg p-4" data-id="element-167">
          <div className="h-4 bg-white/20 rounded w-32 mb-2" data-id="element-168"></div>
          <div className="h-8 bg-white/20 rounded w-40" data-id="element-169"></div>
        </div>)}
    </div>;
}